import { unEscaper } from '@modules/Util/S/Function/util';
import axios from 'axios';
import { AutoCompleteListRetrieveResponse } from '../type/autocomplete';
import { noop } from '@fxts/core';
import { debounceWithFirstCall } from '@services/MarppleShop/shared/util';

export const getAutoCompleteListApi = async (option: {
  search?: string;
  store_id?: number;
}): Promise<AutoCompleteListRetrieveResponse> => {
  const search = unEscaper(option.search ?? '').trim();

  // 2글자 미만일 때는 자동완성 미제공
  if (search.length < 2) {
    return { auto_completes: [] };
  }

  const { data } = await axios.get<AutoCompleteListRetrieveResponse>(`/${ET.lang}/@api/search/autocomplete`, {
    params: { search, store_id: option.store_id },
  });
  return data;
};

export const getCreatorAutoCompleteListApi = async (option: {
  search?: string;
}): Promise<AutoCompleteListRetrieveResponse> => {
  const search = unEscaper(option.search ?? '').trim();

  // 1글자 미만일 때는 자동완성 미제공
  if (search.length < 1) {
    return { auto_completes: [] };
  }

  const { data } = await axios.get<AutoCompleteListRetrieveResponse>(
    `/${ET.lang}/@api/search/creator/autocomplete`,
    {
      params: { search },
    },
  );
  return data;
};

export const postSearchLogApi = debounceWithFirstCall(
  ({ search, is_popular_search_word }: { search: string; is_popular_search_word: boolean }) => {
    axios
      .post(`/${ET.lang}/@api/search/log`, {
        search,
        is_popular_search_word,
      })
      .catch(noop);
  },
  2000,
);
